
import { MapPin, Grid } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ViewToggleProps {
  view: "list" | "map";
  onViewChange: (view: "list" | "map") => void;
}

export const ViewToggle = ({ view, onViewChange }: ViewToggleProps) => {
  return (
    <div className="flex items-center gap-1 p-1 rounded-full bg-muted/60 border border-border/40">
      <Button
        variant={view === "list" ? "default" : "ghost"}
        size="sm"
        onClick={() => onViewChange("list")}
        className={`rounded-full px-3 h-8 text-xs font-medium ${view === "list" ? "shadow-sm" : "hover:bg-transparent"}`}
      >
        <Grid className="h-3.5 w-3.5 mr-1.5" />
        List
      </Button>
      <Button
        variant={view === "map" ? "default" : "ghost"}
        size="sm"
        onClick={() => onViewChange("map")}
        className={`rounded-full px-3 h-8 text-xs font-medium ${view === "map" ? "shadow-sm" : "hover:bg-transparent"}`}
      >
        <MapPin className="h-3.5 w-3.5 mr-1.5" />
        Map
      </Button>
    </div>
  );
};
